import { IncidentStatus } from '../../../shared/objects/incident/incidentStatus';
import { FieldDefinitionModel } from '../field-definition.model';
import { FilterSearch } from '../filter-search.model';
import { FilterModel } from '../filter.model';

import { IncidentDefaultFilters } from './incident-default-filters';

export class IncidentListFilters {
  public static statuses: FilterModel[] = [
    {
      value: '-',
      viewValue: '-',
      option: null,
    },
    {
      value: 'FILTERS.STATUS-OPEN',
      viewValue: 'FILTERS.STATUS-OPEN',
      option: IncidentStatus.Open,
    },
    {
      value: 'FILTERS.STATUS-CLOSED',
      viewValue: 'FILTERS.STATUS-CLOSED',
      option: IncidentStatus.Closed,
    },
  ];

  public static defaultFieldDefinitions: FieldDefinitionModel[] = [
    {
      type: 'select',
      name: 'status',
      placeholder: 'FILTERS.CHOOSE-STATUS',
      disabled: false,
      options: IncidentListFilters.statuses,
      value: 'FILTERS.STATUS-OPEN',
    },
    {
      type: 'rangedatepicker',
      placeholder: 'FILTERS.CHOOSE-DATE-RANGE',
      name: 'dateRange',
    },
  ];

  public static defaultFields: IncidentDefaultFilters = {
    dateRange: null,
    status: 'FILTERS.STATUS-OPEN',
  };

  public static filterSearch: FilterSearch = {
    filter: IncidentListFilters.defaultFields,
    filterSearchValue: '',
  };
}
